import objectPath from "object-path";
import React from "react";
import { connect } from "react-redux";
import { Constants } from "../../../app/utils/Constants";
import * as builder from "../../ducks/builder";

class Footer extends React.Component {
    render() {
        const today = new Date().getFullYear();

        return (
            <div className={`kt-footer ${this.props.footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`} id="kt_footer">
                <div className={`kt-container ${this.props.footerContainerClasses}`}>
                    <div className="kt-footer__copyright">
                        {today.toString()}&nbsp;&copy;&nbsp;
                        <a href={Constants.urlOnboarding} target="_blank" rel="noopener noreferrer" className="kt-link">
                            Masi Negócios
                        </a>
                    </div>

                    <div style={{ display: "flex", gap: 32 }} className="kt-footer__copyright">
                        <a href={Constants.urlOnboarding} target="_blank" rel="noopener noreferrer" className="kt-link">
                            Perguntas Frequentes
                        </a>

                        <a href={Constants.urlOnboarding} target="_blank" rel="noopener noreferrer" className="kt-link">
                            Termos e condições
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    fluid: objectPath.get(store.builder.layoutConfig, "footer.self.width") === "fluid",
    footerClasses: builder.selectors.getClasses(store, {
        path: "footer",
        toString: true,
    }),
    footerContainerClasses: builder.selectors.getClasses(store, {
        path: "footer_container",
        toString: true,
    }),
});

export default connect(mapStateToProps)(Footer);
